import { c as _c } from "react/compiler-runtime";
import ResourcesBase from 'modules/digital-product/resources/components/resources-base';
import { useDigitalResourceContent } from 'modules/digital-product/resources/hooks/use-digital-resource-content';
import { DigitalResourceType } from 'modules/digital-product/resources/types/digital-resource-interface';
import React, { FC } from 'react';
import { DigitalProductErrorInterface } from '../../types/digital-product-interface';
interface Props {
  resources: DigitalResourceType[];
  errors: DigitalProductErrorInterface['resources'];
}
export const ResourcesReadOnly: FC<Props> = t0 => {
  const $ = _c(2);
  const {
    resources,
    errors
  } = t0;
  const existingResourcesData = useDigitalResourceContent(resources, undefined, errors);
  let t1;
  if ($[0] !== existingResourcesData) {
    t1 = <ResourcesBase>{existingResourcesData}</ResourcesBase>;
    $[0] = existingResourcesData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};